import { render, staticRenderFns } from "./youKeRenShu.vue?vue&type=template&id=bc1e87f6&scoped=true&"
import script from "./youKeRenShu.vue?vue&type=script&lang=js&"
export * from "./youKeRenShu.vue?vue&type=script&lang=js&"
import style0 from "./youKeRenShu.vue?vue&type=style&index=0&id=bc1e87f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc1e87f6",
  null
  
)

export default component.exports